import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
// import CardDetailsViewPage from './pages/CardDetailsViewPage';
import DigitalIterface from "./pages/DigitalInterfacePage.js";
import Error404Page from "./pages/Error404Page";
import Card from "./components/store/CardContext";
import ReviewQrInterfacePage from "./pages/ReviewQrInterfacePage";
import ContactCardInterfacePage from "./pages/ContactCardInterfacePage";
// import RouteBasicCardViewPage from './pages/RouteBasicCardViewPage';
import "./i18n.js";
import RedirectionQRInterfacePage from "./pages/RedirectionQRInterfacePage.js";
import DynamicQRInterfacePage from "./pages/DynamicQRInterfacePage.js";
import AutoBiographyPage from "./pages/AutoBiographyPage.js";
import PlanValidation from "./components/store/PlanValidationContext.js";
import SolutionCardPage from "./pages/SolutionCardPage.js";
import RedirectSolutionPage from "./pages/RedirectSolutionPage.js";
import StandardTheme from "./components/digitalInterfaceThemes/standardTheme/StandardTheme";
import ClassicTheme2 from "./components/digitalInterfaceThemes/classicTheme2/ClassicTheme2";


function App() {
  return (
    <Card>
      <PlanValidation>
        <Router>
          <Routes>
            <Route path="/standard-theme" element={<StandardTheme />} />
              <Route path="/classic-theme2" element={<ClassicTheme2 />} />


            <Route path="/" element={<LandingPage />} />
            <Route path="/profile-view/:id" element={<DigitalIterface />} />
            {/* <Route path='/profile-view/:id' element={<CardDetailsViewPage />} /> */}
            {/* <Route path='/profile/:id' element={<RouteBasicCardViewPage />} /> */}
            <Route path="/reviewQR/:id" element={<ReviewQrInterfacePage />} />
            <Route
              path="/contact-card/:id"
              element={<ContactCardInterfacePage />}
            />
            {/* <Route path='/url/:id' element={<RedirectionQRInterfacePage />} /> */}
            <Route path="/:id" element={<DynamicQRInterfacePage />} />
            <Route path="bio/:id" element={<AutoBiographyPage />} />

            <Route path="/solution/:id" element={<SolutionCardPage />} />
            <Route path="/url/:id" element={<RedirectSolutionPage />} />

            <Route path="*" element={<Error404Page />} />
          </Routes>
        </Router>
      </PlanValidation>
    </Card>
  );
}

export default App;
